export enum KEYS  {
  RESORTS = 'resorts'
}